import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_PsuAwardListDto,
} from '../../services/wealthlane-award-services';
// import { ParticipantService } from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetPsuParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  filterData: TableParamsType,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PsuAwardListDto | undefined,
  unknown
> => {
  // const {
  //   approvalStatusId,
  //   optionAcceptance: psuAcceptance,
  //   fromDate,
  //   toDate,
  //   createdFromDate,
  //   createdToDate,
  //   employeeStatusId,
  //   grantFromDate,
  //   grantToDate,
  // } = filterData;

  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance: psuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    grantFromDate,
    grantToDate,
    _force,
  } = tableInfo;
  const psuStatus = 0;

  const PsuParticipantList = useQuery(
    [
      'getPsuParticipantList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      psuStatus,
      psuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        PsuAwardService.getApiAwardApiAppPSUAwardPSUAwardList(
          approvalStatusId ?? [0],
          fromDate,
          toDate,
          employeeStatusId ?? [0],
          psuStatus,
          psuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return PsuParticipantList;
};

export default useGetPsuParticipantList;
